import { Component } from '@opten/compiler/metadata/component';
import addClass from '@opten/dom/add-class';
import hasClass from '@opten/dom/has-class';
import removeClass from '@opten/dom/remove-class';

@Component({ className: 'js-text-collapse' })
export class TextCollapse {
	private heightThreshold = 82;
	private inner: HTMLElement;
	private button: HTMLElement;
	private buttonTextLess: HTMLElement;
	private buttonTextMore: HTMLElement;

	constructor(private element: HTMLElement) {
		this.inner = this.element.querySelector<HTMLElement>('.js-text-collapse-inner');
		this.button = this.element.querySelector<HTMLElement>('.js-text-collapse-btn');
		this.buttonTextMore = this.element.querySelector<HTMLElement>('.js-text-collapse-btn-more');
		this.buttonTextLess = this.element.querySelector<HTMLElement>('.js-text-collapse-btn-less');

		if (this.element.hasAttribute('data-limit-threshold')) {
			this.heightThreshold = +this.element.getAttribute('data-limit-threshold');
		}

		if (element.offsetHeight >= this.heightThreshold) {
			this.initLimitation();
		}
	}

	private initLimitation() {
		this.collapse();
		addClass(this.element, 'limit');

		removeClass(this.button, 'd-none');
		this.button.addEventListener('click', () => this.toggle());
	}

	private toggle() {
		if (hasClass(this.element, 'limit')) {
			this.expand();
			removeClass(this.element, 'limit');
			removeClass(this.buttonTextLess, 'd-none');
			addClass(this.buttonTextMore, 'd-none');
		} else {
			this.collapse();
			addClass(this.element, 'limit');
			addClass(this.buttonTextLess, 'd-none');
			removeClass(this.buttonTextMore, 'd-none');
		}
	}

	private collapse() {
		this.inner.style.height = `${this.heightThreshold}px`;
	}

	private expand() {
		this.inner.style.height = `${this.inner.scrollHeight}px`;
	}
}
